import { LyceoUser } from '../models/lyceo-user.model';
import { USER_PROFILE_MOCK } from '../models/oauth-profile.response.mock';

export const SCHEDULING_TEAM_ACCOUNT: LyceoUser = new LyceoUser({
  ...USER_PROFILE_MOCK,
  roles: ['ROLE_SKOLEO_TT_PLANNER_SCHEDULING_TEAM'],
});

export const LOCATION_MANAGER_ACCOUNT: LyceoUser = new LyceoUser({
  ...USER_PROFILE_MOCK,
  roles: ['ROLE_SKOLEO_TT_PLANNER_LOCATION_MANAGEMENT'],
});

export const ADMIN_ACCOUNT: LyceoUser = new LyceoUser({
  ...USER_PROFILE_MOCK,
  roles: ['ROLE_SKOLEO_TT_PLANNER_ADMIN'],
});
